import { ServerClock } from "odyssey-shared";

/**
 * The page's one copy of the server's clock (PROTOCOL.md 6.100.0, the author's rule of 2026-10-31: everyone shares one game
 * time). The `welcome` sets it; the light cycle, the sky and the weather read it through `serverNow`, never the player's
 * wall clock.
 */
export const PAGE_CLOCK = new ServerClock();

/**
 * The server's time now, carried by the page's monotonic clock from the last `welcome`.
 *
 * @returns Milliseconds since the Unix epoch, or null before a welcome has told the page the time.
 */
export function serverNow(): number | null {
  return PAGE_CLOCK.now(performance.now());
}
